import React from 'react';
import EmployeeQRCode from './EmployeeQRCode';

function EmployeeQRModal({ employee, onClose }) {
  if (!employee) return null;

  return (
    <div className="admin-modal-overlay" onClick={onClose} role="presentation">
      <div
        className="admin-modal admin-modal--qr"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="employee-qr-modal-title"
      >
        <button type="button" className="admin-modal-close" onClick={onClose} aria-label="Close">
          ✕
        </button>
        <h3 id="employee-qr-modal-title" className="admin-modal-qr-title">
          Employee QR Badge
        </h3>
        <p className="admin-modal-qr-subtitle">
          Backup attendance code for {employee.name || 'employee'}
        </p>
        <EmployeeQRCode employee={employee} />
      </div>
    </div>
  );
}

export default EmployeeQRModal;
